import { render } from "./optionManagement.vue?vue&type=template&id=10bfbfce&scoped=true"
import script from "./optionManagement.vue?vue&type=script&lang=js"
export * from "./optionManagement.vue?vue&type=script&lang=js"

import "./optionManagement.vue?vue&type=style&index=0&id=10bfbfce&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10bfbfce"]])

export default __exports__